import colorsOptions from '../stories/fundamentals/colors-styles/constants'
import { triggerVariantStyleOptions } from './constants'

export const getTriggerStyle = (position) => {
  const baseStyle = {
    borderTop: `1px solid ${colorsOptions.greys['grey-20']}`,
    borderBottom: 'none',
    boxShadow: 'none',
    padding: '0.5rem'
  }

  const variations = {
    [triggerVariantStyleOptions.LEFT]: {
      borderRadius: '8px 0 0 0',
      borderLeft: `1px solid ${colorsOptions.greys['grey-20']}`,
      borderRight: 'none'
    },
    [triggerVariantStyleOptions.MIDDLE]: {
      borderLeft: 'none',
      borderRight: 'none'
    },
    [triggerVariantStyleOptions.RIGHT]: {
      borderRadius: '0 8px 0 0',
      borderLeft: 'none',
      borderRight: `1px solid ${colorsOptions.greys['grey-20']}`
    }
  }

  return {
    ...baseStyle,
    ...variations[position]
  }
}
